import { Grid, useEventCallback } from '@mui/material';
import { FormikErrors, FormikTouched } from 'formik';
import { memo } from 'react';
import MunicipalityList, { MunicipalityAnprVM } from 'shell/components/shared/municipality-list';
import PmiTextField from 'shell/components/shared/text-field';
import { noop } from 'shell/utils/noop';
import { DateTime } from 'luxon';

export interface ItalianMunicipality {
  municipalityId?: string;
  municipalityDescription?: string;
  province?: string;
  provinceCode?: string;
  location?: string;
}
interface FormItalyEventProps {
  form: ItalianMunicipality | undefined | null;
  handleChange: (form: ItalianMunicipality) => void;
  errors?: FormikErrors<ItalianMunicipality>;
  touched?: FormikTouched<ItalianMunicipality>;
  fromDate?: DateTime | null;
  disabled?: boolean;
}

const FormItalyEvent = ({
  form,
  handleChange,
  errors,
  touched,
  fromDate,
  disabled,
}: FormItalyEventProps): React.ReactElement => {
  const onChangeMunicipalityList = useEventCallback((municipality: MunicipalityAnprVM | null) => {
    handleChange({
      ...(form || {}),
      provinceCode: municipality?.provinceCode,
      municipalityDescription: municipality?.description,
      municipalityId: municipality?.id,
      province: municipality?.province,
    });
  });

  return (
    <>
      <Grid item xs={12} md={4}>
        <MunicipalityList
          label="Comune"
          fromDate={fromDate}
          disabled={disabled}
          value={
            form?.municipalityId
              ? {
                  id: form?.municipalityId,
                  description: form?.municipalityDescription || '',
                  province: form?.province || '',
                  provinceCode: form?.provinceCode,
                }
              : null
          }
          onChange={onChangeMunicipalityList}
          error={touched && Boolean(errors)}
        />
      </Grid>
      <Grid item xs={12} md={4}>
        <PmiTextField
          id="province"
          label="Provincia"
          aria-label="Provincia"
          disabled
          fullWidth
          onChange={noop}
          value={form?.province || ''}
          error={touched?.province && Boolean(errors?.province)}
          helperText={errors?.province}
        />
      </Grid>
    </>
  );
};

FormItalyEvent.displayName = 'Form evento in Italia';

const FormItalyEventMemo = memo(FormItalyEvent);

export default FormItalyEventMemo;
